import { emailjs } from './config'

export const appendEmailjsFields = (formData: FormData) => {
  formData.append('service_id', emailjs.service_id)
  formData.append('template_id', emailjs.template_id)
  formData.append('user_id', emailjs.user_id)
  formData.append('time', new Date().toISOString())
}
